module.exports = __webpack_public_path__ + "static/team-pole-564203883ec9de3ac89712f2a5d93e80.jpg";